import Vue from 'vue'

import {
  Message,
  MessageBox,
  Button,
  ButtonGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Input,
  Checkbox,
  Select,
  Option,
  OptionGroup,
  Radio,
  RadioButton,
  RadioGroup,
  DatePicker,
  Upload,
  Progress,
  Table,
  TableColumn,
  Tag,
  Dialog,
  Pagination,
  Loading,
  Carousel,
  CarouselItem,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Tooltip,
  CheckboxGroup,
  Tabs,
  TabPane,
  Rate,
  Switch,
  Tree
} from 'element-ui'

const components = [
  Button,
  ButtonGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Input,
  Checkbox,
  Select,
  Option,
  OptionGroup,
  Radio,
  RadioButton,
  RadioGroup,
  DatePicker,
  Upload,
  Progress,
  Table,
  TableColumn,
  Tag,
  Dialog,
  Pagination,
  Carousel,
  CarouselItem,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Tooltip,
  Loading,
  CheckboxGroup,
  Tabs,
  TabPane,
  Rate,
  Switch,
  Tree
]

components.forEach(item => Vue.use(item))

Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt

MessageBox.setDefaults({
  closeOnClickModal: false
})
